import { Countries } from '../../core/util/msisdn';
import storage from './local-storage-wrapper';

const phoneNumberKey = 'remember-me-phone-number';
const countryKey = 'remember-me-country';

const exists = () => {
  return storage.has(phoneNumberKey);
};

const set = (country: Countries, number: string) => {
  storage.set(countryKey, btoa(country));
  storage.set(phoneNumberKey, btoa(number));
};

const clear = () => {
  storage.remove(phoneNumberKey);
  storage.remove(countryKey);
};

const get = () => {
  const encryptedCountry = storage.getText(countryKey);
  const encryptedNumber = storage.getText(phoneNumberKey);

  const country = encryptedCountry === null ? undefined : (atob(encryptedCountry) as Countries);
  const number = encryptedNumber === null ? undefined : atob(encryptedNumber);

  const countryIsInvalid = country !== undefined && !Object.values(Countries).includes(country);
  const numberIsInvalid = number !== undefined && !number.match(/^\d+$/);

  if (countryIsInvalid || numberIsInvalid) {
    clear();
    return { number: undefined, country: undefined };
  }

  return {
    country,
    number,
  };
};

export default {
  isSupported: storage.isSupported,
  exists,
  get,
  clear,
  set,
};
